import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'
import {
  beFiltersApiCreateFilter,
  beFiltersApiEditFilter,
  beFiltersApiGetFilter,
  beFiltersApiSimulateByConf,
} from '../../../api/beFiltersApi'
import { notifyParent } from '../../../helpers/notifyParent'
import { ChannelType, SubscriptionType } from '../../../types/FilterCondition'
import { type UiFilterDetail } from '../filterConditionTypes'
import { type SubscriberCount } from '../types'
import { fromFilterDetail, toFilterDetail } from '../utils/apiMapping'

export const getFilter = async (id: number): Promise<UiFilterDetail> => {
  const filter = await beFiltersApiGetFilter(id)
  return fromFilterDetail(filter)
}

export const saveFilter = async (
  filter: UiFilterDetail,
): Promise<UiFilterDetail> => {
  const dto = toFilterDetail(filter)
  const response =
    dto.Id === 0
      ? await beFiltersApiCreateFilter(dto)
      : await beFiltersApiEditFilter(dto, dto.Id)
  return fromFilterDetail(response)
}

export const simulateSubs = async (
  filter: UiFilterDetail,
): Promise<SubscriberCount> => {
  const filterDto = toFilterDetail(filter)
  const [Email, Sms] = await Promise.all([
    beFiltersApiSimulateByConf(
      storeGet(STORE_KEY_ID_LIST) as number,
      filterDto.Blocks,
      ChannelType.Email,
      [SubscriptionType.Subscribed],
    ),
    beFiltersApiSimulateByConf(
      storeGet(STORE_KEY_ID_LIST) as number,
      filterDto.Blocks,
      ChannelType.Sms,
      [SubscriptionType.Subscribed],
    ),
  ])
  return { Email, Sms }
}

export const goToRecipients = (
  channel: ChannelType,
  filterId: number,
): void => {
  const r = `/recipients/list?sch=${channel}&ssst=optin&saf=${encodeURIComponent(filterId)}`

  notifyParent('redirectMainFrame', [
    `recipients_app_redirector.aspx?r=${encodeURIComponent(r)}`,
  ])
}
